let confirmDirective = function ($modal) {
    return {
        priority: -99,
        restrict: 'A',
        link: function (scope, element, attrs) {
            scope.title = attrs.title || 'Confirm';
            scope.message = attrs.confirm || 'Are you sure?';
            scope.yes = attrs.yes || 'Yes';
            scope.no = attrs.no || 'No';

            element.bind('click', function (event) {
                if (attrs.disabled) {
                    return;
                }

                event.stopImmediatePropagation();
                event.preventDefault();

                let confirm = $modal.open({
                    scope: scope,
                    template: `
            <h3>{{ title }}</h3>

            <p>{{ message }}</p>

            <button type="button" class="button" ng-click="$dismiss()">{{ no }}</button>
            <button type="button" class="button" ng-click="$close()">{{ yes }}</button>
          `,
                    windowClass: 'c-modal__reveal'
                });

                confirm.result.then(() => attrs.ngClick ? scope.$eval(attrs.ngClick) : null).catch(() => { });
            });
        }
    };
};

confirmDirective.$inject = ['$modal'];

export default confirmDirective;



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/base/directives/confirm.directive.js